const SubmitedIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.94243 13.5C8.26085 13.4789 8.55529 13.3235 8.75243 13.0725L13.25243 7.44754C13.544 7.13865 13.6367 6.69186 13.4922 6.29244C13.3476 5.89302 12.9904 5.60908 12.5687 5.55836C12.1469 5.50764 11.7326 5.69879 11.4974 6.05254L7.78493 10.6875L6.42368 9.32629C5.98255 8.88516 5.26732 8.88516 4.82618 9.32629C4.38505 9.76743 4.38505 10.4827 4.82618 10.9238L7.07618 13.1738C7.28849 13.3844 7.57591 13.5018 7.87493 13.5H7.94243Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18ZM7.9425 13.5C8.26091 13.4788 8.55535 13.3234 8.7525 13.0725L13.2525 7.4475C13.5441 7.1386 13.6368 6.69181 13.4922 6.2924C13.3477 5.89298 12.9905 5.60904 12.5687 5.55832C12.147 5.5076 11.7326 5.69875 11.4975 6.0525L7.785 10.6875L6.42375 9.32625C5.98261 8.88511 5.26739 8.88511 4.82625 9.32625C4.38511 9.76739 4.38511 10.4826 4.82625 10.9237L7.07625 13.1737C7.28856 13.3843 7.57597 13.5017 7.875 13.5H7.9425Z"
      fill="#008A07"
    />
  </svg>
);

export default SubmitedIcon;
